import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import P from 'prop-types';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import messageLimiter from '../../helpers/limitMessage';
import getLangData from '../../utils/getLangData';
const ListItem = ({
  name,
  description,
  editLink,
  onDelete,
  viewLink,
  viewCourseLink,
  type,
  data,
  enable,
  onSwich,
  moderated,
  wordLabel,
  proposals,
  onView,
  active = '',
  rejected,
  length
}) => {
  const [visible, setVisable] = useState(false);
  const [switchVisible, setSwitchVisibale] = useState(false);

  console.log(type, 'congar');
  return (
    <tr className='item row'>
      {/** for one column only */}
      {type !== 'multi' && (
        <ContentContainer className='col-sm-12'>
          <ListItemDetails>
            <Link
              to={editLink ? editLink : viewLink}
              style={{
                margin: '3em',
                padding: '1em',
                color: 'black',
                fontSize: '0.85em'
              }}
            >
              {/* {name}
              {moderated ? (
                <span
                  style={{
                    color: 'red',
                    fontWeight: 'bold',
                    marginLeft: '10px',
                  }}
                >
                  (Pending Review)
                </span>
              ) : (
                ''
              )} */}

              {wordLabel ? (
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span
                    className='kt-widget31__username ml-5'
                    style={{
                      fontSize: '0.85em',
                      display: 'flex',
                      flexWrap: 'wrap'
                    }}
                  >
                    {name}{' '}
                    {moderated ? (
                      <span
                        style={{
                          color: 'red',
                          fontWeight: 'bold',
                          marginLeft: '10px'
                        }}
                      >
                        {getLangData().buttons.pending}
                      </span>
                    ) : (
                      ''
                    )}
                  </span>{' '}
                  <span style={{ color: '#ecc063', fontWeight: 'bold' }}>
                    {wordLabel
                      ? wordLabel
                      : `${getLangData().fields.proposal} : ${proposals.length
                      }`}
                  </span>
                </div>
              ) : (
                <span
                  className='kt-widget31__username ml-5'
                  style={{
                    fontSize: '0.85em',
                    display: 'flex',
                    flexWrap: 'wrap'
                  }}
                >
                  {name}{' '}
                  {moderated ? (
                    <span
                      style={{
                        color: 'red',
                        fontWeight: 'bold',
                        marginLeft: '10px'
                      }}
                    >
                      {/* {wordLabel ? wordLabel : '(Pending Review)'}
                       */}
                      {getLangData().buttons.pending}
                    </span>
                  ) : (
                    ''
                  )}
                </span>
              )}
            </Link>
            {description ? <p>{description}</p> : null}
            {/* <p className='kt-widget31__text'>{messageLimiter(description, 17)}</p> */}
          </ListItemDetails>
        </ContentContainer>
      )}

      {/** to make the code simple, you might need to create another component for this */}
      {/** for multi columns */}
      {type === 'multi' &&
        data.map(item => {
          return (
            <ContentContainer
              className='kt-widget31__content col-sm-12'
              key={item}
            >
              <ListItemDetails className='kt-widget31__info'>
                {/* <span
                  className="kt-widget31__username ml-5"
                  style={{
                    fontSize: '0.85em',
                    display: 'flex',
                    flexWrap: 'wrap',
                  }}
                >
                  {item} {moderated ? <span style={{color: 'red' , fontWeight: 'bold', marginLeft: '10px'}}>(Pending Review)</span> : ''}
                </span> */}
                {active && (
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span
                      className='kt-widget31__username ml-5'
                      style={{
                        fontSize: '0.85em',
                        display: 'flex',
                        flexWrap: 'wrap'
                      }}
                    >
                      <span style={{ color: '#ecc063', fontWeight: 'bold' }}>
                        {active}
                      </span>
                    </span>
                  </div>
                )}
                {proposals ? (
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span
                      className='kt-widget31__username ml-5'
                      style={{
                        fontSize: '0.85em',
                        display: 'flex',
                        flexWrap: 'wrap'
                      }}
                    >
                      {item}{' '}
                      {moderated ? (
                        <span
                          style={{
                            color: 'red',
                            fontWeight: 'bold',
                            marginLeft: '10px'
                          }}
                        >
                          {getLangData().buttons.pending}
                        </span>
                      ) : (
                        ''
                      )}
                    </span>{' '}
                    <span style={{ color: '#ecc063', fontWeight: 'bold' }}>
                      {getLangData().fields.proposal} : {proposals.length}
                    </span>
                  </div>
                ) : (
                  <span
                    className='kt-widget31__username ml-5'
                    style={{
                      fontSize: '0.85em',
                      display: 'flex',
                      flexWrap: 'wrap'
                    }}
                  >
                    {item}{' '}
                    {moderated ? (
                      <span
                        style={{
                          color: 'red',
                          fontWeight: 'bold',
                          marginLeft: '10px'
                        }}
                      >
                        {/* {wordLabel ? wordLabel : '(Pending Review)'}
                         */}
                        {getLangData().buttons.pending}
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                )}
                {/* {wordLabel ? (
     
                */}
              </ListItemDetails>
            </ContentContainer>
          );
        })}
      {/* <div
        style={{ color: '#ecc063', fontWeight: 'bold' }}
        className='my-auto mr-3'
      >
        {length}
      </div> */}

      <ActionsContainer className='actions '>
        <div className='d-flex align-items-center' style={{ height: '100%' }}>
          {editLink ? (
            <Link
              to={editLink}
              className='btn edit'
              data-toggle='tooltip'
              data-placement='top'
              title={getLangData().buttons.edit}
            >
              {/* <em className="icon-action-edit-warshatna"></em> */}
              <i className='far fa-edit '></i>
            </Link>
          ) : (
            ''
          )}

          {viewLink ? (
            <Link
              to={viewLink}
              className='btn view'
              data-toggle='tooltip'
              data-placement='top'
              title={getLangData().buttons.view}
            >
              {/* <em className="icon-action-open-warshatna"></em> */}
              <i className='fas fa-search-plus'></i>
              {/* <i class="far fa-eye"></i> */}
            </Link>
          ) : (
            ''
          )}

          {viewCourseLink ? (
            <Link
              to={viewCourseLink}
              className='btn view'
              data-toggle='tooltip'
              data-placement='top'
              title={getLangData().fields.courses}
            >
              {/* <em className="icon-action-open-warshatna"></em> */}
              <i className='fas fa-search-plus'></i>
              {/* <i class="far fa-eye"></i> */}
            </Link>
          ) : (
            ''
          )}

          {!rejected && onDelete && (
            <Tooltip
              placement='topRight'
              trigger={['click']}
              animation='zoom'
              overlayInnerStyle={{ backgroundColor: 'white' }}
              onVisibleChange={visible => setVisable(visible)}
              visible={visible}
              overlay={
                <div>
                  <p>Are you sure you want to delete this record?</p>
                  <p>This process can't be undone.</p>
                  <div className='btns'>
                    <button
                      onClick={() => setVisable(false)}
                      className='btn btn-sm btn-label-primary'
                    >
                      {getLangData().general_words.No}
                    </button>
                    <button
                      onClick={() => {
                        onDelete();
                        setVisable(false);
                      }}
                      className='btn btn-sm btn-danger ml-1'
                    >
                      {getLangData().general_words.yes}
                    </button>
                  </div>
                </div>
              }
              destroyTooltipOnHide={true}
              overlayClassName={'tooltip-overlay'}
            >
              <button
                type='button'
                className='btn trash'
                data-toggle='tooltip'
                data-placement='top'
                title={getLangData().buttons.delete}
              >
                {/* <em className="icon-action-trash-warshatna"></em>
                 */}
                <i className='fas fa-trash'></i>
              </button>
            </Tooltip>
          )}

          {onSwich && (
            <Tooltip
              placement='topRight'
              trigger={['click']}
              animation='zoom'
              overlayInnerStyle={{ backgroundColor: 'white' }}
              onVisibleChange={visible => setSwitchVisibale(visible)}
              visible={switchVisible}
              overlay={
                <div>
                  <p>
                    Are you sure you want to {enable ? 'disable' : 'enable'}{' '}
                    this record?
                  </p>
                  <div className='btns'>
                    <button
                      onClick={() => setSwitchVisibale(false)}
                      className='btn btn-sm btn-label-primary'
                    >
                      {getLangData().general_words.No}
                    </button>
                    <button
                      onClick={() => {
                        onSwich();
                        setSwitchVisibale(false);
                      }}
                      className='btn btn-sm btn-danger ml-1'
                    >
                      {getLangData().general_words.yes}
                    </button>
                  </div>
                </div>
              }
              destroyTooltipOnHide={true}
              overlayClassName={'tooltip-overlay'}
            >
              <button
                type='button'
                className='btn trash'
                data-toggle='tooltip'
                data-placement='top'
                title='Toggle'
              >
                {/* <em className="icon-action-trash-warshatna"></em>
                 */}
                {enable ? (
                  <i class='fas fa-toggle-on'></i>
                ) : (
                  <i class='fas fa-toggle-off'></i>
                )}
              </button>
            </Tooltip>
          )}
        </div>
      </ActionsContainer>
    </tr>
  );
};

const ContentContainer = styled.td`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  border: none !important;
`;

const ListItemDetails = styled.div`
  padding: 0 !important;
  margin-right: 10px;
  flex: 1;
  flex-shrink: 0;
  font-weight: bold;
`;

const ActionsContainer = styled.td`
  justify-content: flex-end !important;
  width: unset !important;
  > * {
    margin-left: 10px;
  }
  width: 200px;
  text-align: center;
  background: var(--gold-color);
`;

ListItem.propTypes = {
  name: P.string.isRequired,
  enable: P.bool,
  editLink: P.string,
  viewLink: P.string,
  // onDelete: P.func,
  onSwich: P.func,
  description: P.string,
  type: P.string,
  data: P.array
  // wordLabel: P.bool,
};

ListItem.defaultProps = {
  description: '',
  onDelete: null,
  viewLink: null
};

export default ListItem;
